import Vue from 'vue'
import { 
    Lazyload,
    Search,
    Button,
    Image,
    Pagination,
    Row,
    Col, 
    Rate,
    Dialog,
    Icon,
    Toast,
    Empty 
} from 'vant'

Vue.use(Lazyload)
.use(Search)
.use(Button)
.use(Image)
.use(Pagination)
.use(Row)
.use(Col)
.use(Rate)
.use(Dialog)
.use(Icon)
.use(Toast)
.use(Empty)


// WEBPACK FOOTER //
// ./src/util/vant.js